import React, { Component } from 'react'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

import './index.scss'

class QlikTasuvisitanalysis extends Component {

  constructor(props) {
    super(props)
    this.mobileWidth = 0
    this.state = {
      width: window.innerWidth
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  }

  render() {
    const url = "https://qlik.unifi.id/external-ticket-authentication/single/?appid=6cf63824-1add-4f13-b403-e8d5bcaa47db&sheet=a21fe83d-f6d5-4e51-805b-94114e9ac282&opt=currsel%2Cctxmenu&select=clearall"
    return (
      <PageContainer>
        <iframe src={url} />
      </PageContainer>
    )
  }
}

export default userIsAuthenticatedRedir(QlikTasuvisitanalysis)



// WEBPACK FOOTER //
// ./src/pages/qlik-reports/tasu/visitanalysis/index.js